import { gsap } from 'gsap';
import { computed } from 'vue';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import {
  asbisUiPlugin,
  createWordpressBlogFetcher,
  definePluginOptions,
} from '@webplatform/asbis-ui/integrations/nuxt';
import { createDataLoaders } from '~/lib/asbis-ui';

const TRACKED_SECTIONS = [
  'FeatureSection3dModel',
  'FormSectionSimple',
  'FormSectionTextImage',
];

const pushToDataLayer = ({ event, section, data }) => {
  if (!import.meta.client || !TRACKED_SECTIONS.includes(section)) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ab_data: null });
  window.dataLayer.push({ event, ab_section: section, ab_data: data });
};

const fetchBlogPosts = createWordpressBlogFetcher({
  request: (url, options) => $fetch(url, options),
  timeout: 5000,
});

export default defineNuxtPlugin({
  name: 'canyon:asbis-ui',
  dependsOn: ['frontkit:cms-api'],
  setup({ $i18n, $localePath, vueApp, $api, $httpClient }) {
    const { frontkit } = useRuntimeConfig().public;
    const { asbisUiConfig = {} } = frontkit;

    const locale = computed(() => $i18n?.locale?.value ?? 'en');
    const localePath = (path) => $localePath?.(path) ?? path;

    const options = definePluginOptions({
      ...asbisUiConfig,
      gsap,
      ScrollTrigger,
      currentLanguage: locale,
      productCardLinkPrefix: '/product',
      localePath,
      // Added on main in CAN-854 for asbis-ui 2.63.0; the key lives under
      // `runtimeConfig.public.frontkit` here rather than on Nuxt 2's `$config`
      googleMapsApiKey: frontkit.gmapId,
      dataFetchFunctions: {
        ...createDataLoaders($api, $httpClient, locale),
        fetchBlogPosts,
      },
      analytics: { enabled: true, handler: pushToDataLayer },
    });

    vueApp.use(asbisUiPlugin, options);
  },
});
